import React, {useState} from "react"
import IconSearch from "../iconComponents/IconSearch";

export default function SearchBar(props) {
    const [focus, setFocus] = useState(false);
    return (
        <div className={"searchbar " + (props.spacing ? props.spacing : "") }>
            <input 
                className="input-search"
                type="text" 
                value={props.value} 
                onChange={props.onChange} 
                placeholder={props.placeholder} 
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                id={props.id}
            />
            <IconSearch height="14px" className="icon-search" pathClass={focus ? "g2-fill" : "g6-fill"}/>
        </div>
    )
}
